import React, { useContext, useState } from "react";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";
import SuccessImage from "../../../images/sidebar/SuccessImage";
import { PartialType } from "../Revoke/PartialRevokeTable";

const PartActionModal = ({
  cancelFunction,
  invocationState,
  setReRender,
  reRender,
  selectedArray,
  orderId,
  isOd,
  setIndexRerender,
  setPartUserView,
}) => {
  const [succesState, setSuccesState] = useState(false);
  const [password, setPassword] = useState("");
  const [invokeNow, setInvokeNow] = useState(false);
  const [error, setError] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const type = useContext(PartialType);
  invocationState = "initiatedInvocation";

  const getOverdraftRevokeArray = () => {
    return selectedArray
      .filter((data) => data.selected)
      .map((data) => ({
        qty: data.unit,
        security_uuid: data.uuid,
      }));
  };
  const getTermLoanRevokeArray = () => {
    return selectedArray
      .filter((data) => data.selected)
      .map((data) => ({
        reference_no: data.pledge_no,
        qty: data.unit,
        repository: data.repository,
      }));
  };
  const transformedArray = isOd
    ? getOverdraftRevokeArray()
    : getTermLoanRevokeArray();

  const handlePartialRevokeOverDraft = async () => {
    // console.log(selectedItems);
    setImageLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/bajaj_finserv/service/securities_revocation`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          securities_revocation: {
            password: password,
            order_uuid: orderId,
            securities_to_revoke: transformedArray,
          },
        },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.status === true) {
        setInvokeNow(true);
        setTimeout(() => {
          setIndexRerender((prev) => !prev);
          setPartUserView(false);
        }, 3000);

        // console.log(res.data.message);
      } else {
        setError(res.data?.error || "Something went wrong");
      }
    } catch (error) {
      // console.log(error.response.data.message);
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setImageLoading(false);
    }
  };
  const handlePartialRevoke = async () => {
    // console.log(selectedItems);
    setImageLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/${
          type === "revoke" ? type : "invoke"
        }/partial_${type === "revoke" ? type : "invoke"}`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          confirm_password: password,
          order_uuid: orderId,
          pledged_asset: transformedArray,
        },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.message.message === "SUCCESS") {
        setInvokeNow(true);

        setTimeout(() => {
          setReRender(!reRender);
          cancelFunction(false);
        }, 3000);

        // console.log(res.data.message);
      } else {
        setError(res.data?.message?.remarks);
      }
    } catch (error) {
      // console.log(error.response.data.message);
      setError(error.response?.data?.message || "Something went wrong");
    } finally {
      setImageLoading(false);
    }
  };

  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[360px]  !justify-normal  relative !p-0 !text-left !min-h-[200px] !h-fit ${
          error ? " !min-h-[200px] !h-fit" : ""
        } `}
      >
        {!succesState &&
          !invokeNow &&
          invocationState === "initiatedInvocation" && (
            <>
              {imageLoading && (
                <div className="w-full !h-full flex items-center justify-center  my-auto">
                  <ImageLoading />
                </div>
              )}
              {!imageLoading && (
                <div className="pb-4">
                  <p className=" text-base font-semibold mt-[24px] pl-6">
                    Part {type === "revoke" ? "Revoke" : "Invoke"} Now
                  </p>
                  <p className=" text-xs font-medium mt-[12px] pl-6 text-[#848484] mb-4">
                    To part {type === "revoke" ? "revoke" : "invoke"} now,
                    please enter the password.{" "}
                  </p>
                  <div className=" pr-6">
                    <label className=" text-sm font-medium pl-6">
                      Password
                    </label>
                    <input
                      type="password"
                      autoComplete="new-password"
                      className=" hidden"
                    />
                    <input
                      value={password}
                      autoComplete="new-password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      type="password"
                      placeholder="Password"
                      className=" border border-[#656565] rounded text-xs font-medium w-[90%] h-[44px] pl-2 mt-2 ml-6 mr-6 focus:outline-none"
                    ></input>
                    {error && (
                      <p className=" ml-[25px] font-normal mt-1  text-xs text-red-500">
                        {error}
                      </p>
                    )}
                  </div>

                  <div className=" mt-6 flex justify-center ">
                    <button
                      className=" rounded w-[120px] px-4 py-[3px] border border-[#00394d] text-sm font-semibold text-[#00394d] h-[44px] mr-3"
                      onClick={() => cancelFunction(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        if (password === "") {
                          setError("Password is required");
                          return;
                        }
                        // handlePartialRevoke();
                        if (isOd) {
                          handlePartialRevokeOverDraft();
                        } else {
                          handlePartialRevoke();
                        }
                        // console.log(transformedArray);
                      }}
                      className=" w-[120px] rounded px-4 py-[3px]  bg-[#00394d] text-sm font-semibold text-white h-[44px]"
                    >
                      {type === "revoke" ? "Revoke Now" : "Invoke Now"}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

        {invokeNow && (
          <div className=" w-full h-full flex justify-center flex-col items-center my-auto">
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">
              {type === "revoke" ? "Revoke" : "Invoke"} now, successful!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartActionModal;
